

























































import vue, {PropType} from 'vue';
import {Editor, EditorContent} from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import SmileyAdd from '@/components/admin/SmileyAdd.vue';
import {Link} from '@tiptap/extension-link';
import AddLink from '@/components/admin/AddLink.vue';
import {TranslateResult} from 'vue-i18n';
import {AdminMessageType} from '@/store/modules/Conversations/state';

interface ComponentData {
  editor: {
    focused: boolean;
    content: null | Editor;
  };
  firstUpdate: boolean;
}

export default vue.extend({
  name: 'RichTextEditor',

  components: {AddLink, SmileyAdd, EditorContent},

  props: {
    errorMessage: {
      required: false,
      type: String as PropType<string>,
      default: '',
    },
    label: {
      required: true,
      type: String as PropType<TranslateResult>,
      default: '',
    },
    message: {
      required: true,
      type: String as PropType<string>,
    },
    type: {
      required: false,
      type: Number as PropType<AdminMessageType>,
      default: 0,
    },
  },

  data: (): ComponentData => ({
    editor: {
      content: null,
      focused: false,
    },
    firstUpdate: true,
  }),

  watch: {
    message: function () {
      if (!!this.editor.content && this.firstUpdate) {
        this.firstUpdate = false;
      }

      if (this.message && this.firstUpdate) {
        (this.editor.content as Editor).destroy();

        this.editor.content = new Editor({
          content: this.message,
          extensions: [
            StarterKit,
            Link.configure({
              openOnClick: false,
              autolink: false,
            }),
          ],
          onUpdate: (): void => {
            if (this.editor.content) {
              this.$emit('update:message', this.editor.content.getHTML());
            }
          },
          onFocus: (): void => {
            this.editor.focused = true;
          },
          onBlur: (): void => {
            this.editor.focused = false;
          },
        });

        this.firstUpdate = false;
      }

      if (this.message === '' && this.editor.content) {
        this.editor.content.destroy();
        this.initEditor();
      }
    },

    type: function () {
      if (this.editor.content) {
        this.editor.content.destroy();
      }

      this.initEditor(
          this.type === AdminMessageType.EULA
              ? this.$t('admin.message.form.defaultValues.content') as string
              : '',
      );
    },
  },

  computed: {
    hasMessage(): boolean {
      return this.message !== '' && this.message !== '<p></p>';
    },
    formatting(): number[] {
      const formatting: number[] = [];
      if (this.editor.content === null) return formatting;
      if ((this.editor.content as Editor).isActive('bold')) formatting.push(0);
      if ((this.editor.content as Editor).isActive('italic')) formatting.push(1);

      return formatting;
    },
    lists(): number | undefined {
      if (this.editor.content === null) return undefined;
      if ((this.editor.content as Editor).isActive('bulletList')) return 0;
      if ((this.editor.content as Editor).isActive('orderedList')) return 1;

      return undefined;
    },
  },

  mounted() {
    this.initEditor();
  },

  beforeDestroy() {
    if (this.editor.content) {
      this.editor.content.destroy();
    }
  },

  methods: {
    initEditor(content = ''): void {
      this.editor.content = new Editor({
        content,
        extensions: [
          StarterKit,
          Link.configure({
            openOnClick: false,
            autolink: false,
          }),
        ],
        onUpdate: (): void => {
          if (this.editor.content) {
            this.$emit('update:message', this.editor.content.getHTML());
          }
        },
        onFocus: (): void => {
          this.editor.focused = true;
        },
        onBlur: (): void => {
          this.editor.focused = false;
        },
      });
    },
  },
});
